import React, { Component } from 'react';
import sty from 'styled-components';
import Axios from 'axios';

export default class Add extends Component {
    constructor(props){
        super(props);
        this.state = {
            campaigns: [],
            index: 0,
            matches: window.matchMedia("(min-width: 768px)").matches
        }
        this.getAdds = this.getAdds.bind(this);
    }
    async getAdds(){
        const data = await Axios.post(
            'https://atibaiatv.rj.r.appspot.com', 
            {
                query: `
                    query {
                        getAdds {
                        id
                        name
                        url
                        images {
                            small {
                                url
                                path
                            }
                            medium {
                                url,
                                path
                            }
                            large {
                                url
                                path
                            }
                        }
                        }
                    }
                `
            },{
                headers: {
                    'Content-Type': 'application/json'
                }
            }
        );
        console.log(data);
        
        if(data.status === 200){
            this.setState({
                campaigns: data.data.data.getAdds
            })
        }
    }
    componentDidMount(){
        const handler = e => this.setState({matches: e.matches});
        window.matchMedia("(min-width: 768px)").addListener(handler);
        this.getAdds();
        setInterval(()=>{
            const index = this.state.index === this.state.campaigns.length-1 ? 0 : (this.state.index+1)
            this.setState({index: index})
        }, 20000)
    }
    render(){
        var url = this.state.campaigns.length ? this.state.campaigns[this.state.index].url : '';
        if(!url.startsWith("www.")&& !url.startsWith("http://")){
            url = "www."+url;
        }
        if(!url.startsWith("http://")){
            url = "http://"+url;
        }
        return this.state.campaigns.length ? <Direct target="blank" href={url}>
            <AddImage className={this.props.className} src={!this.props.forceLarge ? !this.state.matches ? this.state.campaigns[this.state.index].images.small.url : this.state.campaigns[this.state.index].images.large.url: this.state.campaigns[this.state.index].images.large.url} />
        </Direct> : null
    }
}

const Direct = sty.div`
    width: 100%
`
const AddImage = sty.img`
    border-radius: 0.5rem;
    box-shadow: 0 .1rem .3rem #888a;
    width: 100%;
`